import { Swiper, SwiperSlide } from "swiper/react";
import React from "react";
import "swiper/css"; // Import Swiper styles
import "swiper/css/navigation"; // Optional: for navigation buttons
import "swiper/css/pagination";

import { MdChevronRight } from "react-icons/md";

import trungtam_daotao from "../../assets/images/trungtam_daotao.webp";
import ite from "../../assets/images/ite.webp";
import cdsyte from "../../assets/images/cdsyte.webp";
import qlgd from "../../assets/images/qlgd.webp";
import udcdsyt from "../../assets/images/udcdsyte.webp";

export default function Swipi() {
  return (
    <div>
      <div className="block lg:hidden mt-7">
        <Swiper
          spaceBetween={20}
          slidesPerView={1}
          breakpoints={{
            sm: {
              slidesPerView: 7,
            },
            lg: {
              slidesPerView: 10,
            },
          }}
          className="mySwiper"
        >
          <SwiperSlide>
            <div className=" shadow-custom max-w-full rounded-[20px] h-auto object-cover border border-solid border-[#E2E2E2]">
              <div>
                <img
                  src={ite}
                  alt="img"
                  className="w-full h-auto rounded-t-[20px] "
                />
              </div>

              <div className="flex flex-col gap-3 bg-white px-[30px] py-[16px] h-[10rem] ">
                <div className="w-[86px] h-[32px] bg-[#27C6FF] rounded-[16px] absolute bottom-[143px] z-10 flex items-center justify-center">
                  <p className="text-[16px] font-normal text-white">Sự kiện</p>
                </div>
                <p className="text-[18px] font-normal text-[#0C5393]">
                  29/10/2024
                </p>
                <p className="text-[16px] font-semibold text-[#333333]">
                  Giải Pháp Phần Mềm Y Tế: Ứng Dụng Công Nghệ trong Chăm Sóc Sức
                  Khỏe
                </p>
                <a href="/new-detail">
                  <div className="flex items-center absolute bottom-2 gap-2 text-[16px] font-normal text-[#1C9BDB] hover:text-blue-800">
                    <p>Xem chi tiết</p>
                    <MdChevronRight />
                  </div>
                </a>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className=" shadow-custom max-w-full rounded-[20px] h-auto object-cover border border-solid border-[#E2E2E2]">
              <div>
                <img
                  src={trungtam_daotao}
                  alt="img"
                  className="w-full h-auto rounded-t-[20px] "
                />
              </div>

              <div className="flex flex-col gap-3 bg-white px-[30px] py-[16px] h-[10rem] ">
                <div className="w-[86px] h-[32px] bg-[#27C6FF] rounded-[16px] absolute bottom-[143px] z-10 flex items-center justify-center">
                  <p className="text-[16px] font-normal text-white">Tin tức</p>
                </div>
                <p className="text-[18px] font-normal text-[#0C5393]">
                  29/10/2024
                </p>
                <p className="text-[16px] font-semibold text-[#333333]">
                  Phần Mềm Quản Trị Trung Tâm Đào Tạo: Tối Ưu Hóa Quản Lý Và
                  Nâng Cao Hiệu Suất
                </p>
                <a href="/new-detail">
                  <div className="flex items-center absolute bottom-2 gap-2 text-[16px] font-normal text-[#1C9BDB] hover:text-blue-800">
                    <p>Xem chi tiết</p>
                    <MdChevronRight />
                  </div>
                </a>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className=" shadow-custom max-w-full rounded-[20px] h-auto object-cover border border-solid border-[#E2E2E2]">
              <div>
                <img
                  src={cdsyte}
                  alt="img"
                  className="w-full h-auto rounded-t-[20px] "
                />
              </div>
              <div className="flex flex-col gap-3 bg-white px-[30px] py-[16px] h-[10rem] ">
                <div className="w-[86px] h-[32px] bg-[#27C6FF] rounded-[16px] absolute bottom-[143px] z-10 flex items-center justify-center">
                  <p className="text-[16px] font-normal text-white">Tin tức</p>
                </div>
                <p className="text-[24px] font-semibold text-[#0C5393]">
                  29/10/2024
                </p>
                <p className="text-[16px] font-normal text-[#333333]">
                  Chuyển Đổi Số Trong Y Tế: Tương Lai Của Hệ Thống Chăm Sóc Sức
                  Khỏe
                </p>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className=" shadow-custom max-w-full rounded-[20px] h-auto object-cover border border-solid border-[#E2E2E2]">
              <div>
                <img
                  src={qlgd}
                  alt="img"
                  className="w-full h-auto rounded-t-[20px] "
                />
              </div>

              <div className="flex flex-col gap-3 bg-white px-[30px] py-[16px] h-[10rem] ">
                <div className="w-[86px] h-[32px] bg-[#27C6FF] rounded-[16px] absolute bottom-[143px] z-10 flex items-center justify-center">
                  <p className="text-[16px] font-normal text-white">Tin tức</p>
                </div>
                <p className="text-[18px] font-normal text-[#0C5393]">
                  29/10/2024
                </p>
                <p className="text-[16px] font-semibold text-[#333333]">
                  Giải Pháp Phần Mềm Quản Lý Giáo Dục: Tăng Hiệu Quả Và Nâng Cao
                  Chất Lượng Dạy Học
                </p>
                <a href="/new-detail">
                  <div className="flex items-center absolute bottom-2 gap-2 text-[16px] font-normal text-[#1C9BDB] hover:text-blue-800">
                    <p>Xem chi tiết</p>
                    <MdChevronRight />
                  </div>
                </a>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
      <div className="hidden lg:block lg:mt-7">
        <Swiper
          spaceBetween={20}
          slidesPerView={4}
          breakpoints={{
            sm: {
              slidesPerView: 7,
            },
            lg: {
              slidesPerView: 10,
            },
          }}
          className="mySwiper"
        >
          <SwiperSlide>
            <div className=" shadow-custom max-w-full rounded-[20px] h-auto object-cover border border-solid border-[#E2E2E2]">
              <div>
                <img
                  src={ite}
                  alt="img"
                  className="w-full h-auto rounded-t-[20px] "
                />
              </div>

              <div className="flex flex-col gap-3 bg-white px-[30px] py-[16px] h-[10rem] ">
                <div className="w-[86px] h-[32px] bg-[#27C6FF] rounded-[16px] absolute bottom-[143px] z-10 flex items-center justify-center">
                  <p className="text-[16px] font-normal text-white">Tin tức</p>
                </div>
                <p className="text-[18px] font-normal text-[#0C5393]">
                  29/10/2024
                </p>
                <p className="text-[16px] font-semibold text-[#333333]">
                  Giải Pháp Phần Mềm Y Tế: Ứng Dụng Công Nghệ trong Chăm Sóc Sức
                  Khỏe
                </p>
                <a href="/new-detail">
                  <div className="flex items-center absolute bottom-2 gap-2 text-[16px] font-normal text-[#1C9BDB] hover:text-blue-800">
                    <p>Xem chi tiết</p>
                    <MdChevronRight />
                  </div>
                </a>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className=" shadow-custom max-w-full rounded-[20px] h-auto object-cover border border-solid border-[#E2E2E2]">
              <div>
                <img
                  src={trungtam_daotao}
                  alt="img"
                  className="w-full h-auto rounded-t-[20px] "
                />
              </div>

              <div className="flex flex-col gap-3 bg-white px-[30px] py-[16px] h-[10rem] ">
                <div className="w-[86px] h-[32px] bg-[#27C6FF] rounded-[16px] absolute bottom-[143px] z-10 flex items-center justify-center">
                  <p className="text-[16px] font-normal text-white">Tin tức</p>
                </div>
                <p className="text-[18px] font-normal text-[#0C5393]">
                  29/10/2024
                </p>
                <p className="text-[16px] font-semibold text-[#333333]">
                  Phần Mềm Quản Trị Trung Tâm Đào Tạo: Tối Ưu Hóa Quản Lý Và
                  Nâng Cao Hiệu Suất
                </p>
                <a href="/new-detail">
                  <div className="flex items-center absolute bottom-2 gap-2 text-[16px] font-normal text-[#1C9BDB] hover:text-blue-800">
                    <p>Xem chi tiết</p>
                    <MdChevronRight />
                  </div>
                </a>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className=" shadow-custom max-w-full rounded-[20px] h-auto object-cover border border-solid border-[#E2E2E2]">
              <div>
                <img
                  src={cdsyte}
                  alt="img"
                  className="w-full h-auto rounded-t-[20px] "
                />
              </div>

              <div className="flex flex-col gap-3 bg-white px-[30px] py-[16px] h-[10rem] ">
                <div className="w-[86px] h-[32px] bg-[#27C6FF] rounded-[16px] absolute bottom-[143px] z-10 flex items-center justify-center">
                  <p className="text-[16px] font-normal text-white">Tin tức</p>
                </div>
                <p className="text-[18px] font-normal text-[#0C5393]">
                  29/10/2024
                </p>
                <p className="text-[16px] font-semibold text-[#333333]">
                  Chuyển Đổi Số Trong Y Tế: Tương Lai Của Hệ Thống Chăm Sóc Sức
                  Khỏe
                </p>
                <a href="/new-detail">
                  <div className="flex items-center absolute bottom-2 gap-2 text-[16px] font-normal text-[#1C9BDB] hover:text-blue-800">
                    <p>Xem chi tiết</p>
                    <MdChevronRight />
                  </div>
                </a>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className=" shadow-custom max-w-full rounded-[20px] h-auto object-cover border border-solid border-[#E2E2E2]">
              <div>
                <img
                  src={qlgd}
                  alt="img"
                  className="w-full h-auto rounded-t-[20px] "
                />
              </div>
              <div className="flex flex-col gap-3 bg-white px-[30px] py-[16px] h-[10rem] ">
                <div className="w-[86px] h-[32px] bg-[#27C6FF] rounded-[16px] absolute bottom-[143px] z-10 flex items-center justify-center">
                  <p className="text-[16px] font-normal text-white">Tin tức</p>
                </div>
                <p className="text-[18px] font-normal text-[#0C5393]">
                  29/10/2024
                </p>
                <p className="text-[16px] font-semibold text-[#333333]">
                  Giải Pháp Phần Mềm Quản Lý Giáo Dục: Tăng Hiệu Quả Và Nâng Cao
                  Chất Lượng Dạy Học
                </p>
                <a href="/new-detail">
                  <div className="flex items-center absolute bottom-2 gap-2 text-[16px] font-normal text-[#1C9BDB] hover:text-blue-800">
                    <p>Xem chi tiết</p>
                    <MdChevronRight />
                  </div>
                </a>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className=" shadow-custom max-w-full rounded-[20px] h-auto object-cover border border-solid border-[#E2E2E2]">
              <div>
                <img
                  src={udcdsyt}
                  alt="img"
                  className="w-full h-auto rounded-t-[20px] "
                />
              </div>

              <div className="flex flex-col gap-3 bg-white px-[30px] py-[16px] h-[10rem] ">
                <div className="w-[86px] h-[32px] bg-[#27C6FF] rounded-[16px] absolute bottom-[143px] z-10 flex items-center justify-center">
                  <p className="text-[16px] font-normal text-white">Tin tức</p>
                </div>
                <p className="text-[18px] font-normal text-[#0C5393]">
                  29/10/2024
                </p>
                <p className="text-[16px] font-semibold text-[#333333]">
                  Ứng Dụng Chuyển Đổi Số Trong Y Tế: Tăng Cường Chăm Sóc Sức
                  Khỏe Và Hiệu Quả Vận Hành
                </p>
                <a href="/new-detail">
                  <div className="flex items-center absolute bottom-2 gap-2 text-[16px] font-normal text-[#1C9BDB] hover:text-blue-800">
                    <p>Xem chi tiết</p>
                    <MdChevronRight />
                  </div>
                </a>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
    </div>
  );
}
